import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import QuickForm from '../components/forms/QuickForm';
import { School, Users, Clock, CheckCircle2, Settings, Phone, ArrowRight } from 'lucide-react';

export default function SkoleniProSkoly() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-white to-cyan-50/30" />
          <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-teal-100/30 rounded-full blur-3xl" />
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6">
                Školení AI pro pedagogy přímo ve vaší škole
              </h1>
              
              <p className="text-xl text-slate-600 mb-8 leading-relaxed">
                Ředitelé škol mohou objednat školení pro své pedagogy přímo ve škole.
              </p>

              <div className="bg-teal-50 border border-teal-100 rounded-xl p-6 mb-8 max-w-2xl mx-auto">
                <p className="text-lg text-slate-700 leading-relaxed mb-4">
                  Obsah školení vždy přizpůsobujeme typu školy (MŠ, ZŠ, SŠ).
                </p>
                <div className="flex flex-wrap justify-center gap-6 text-slate-700">
                  <div className="flex items-center gap-2">
                    <Users className="w-5 h-5 text-teal-600" />
                    <span className="font-semibold">Minimální počet pedagogů: 8</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Settings className="w-5 h-5 text-teal-600" />
                    <span className="font-semibold">Možnost přizpůsobení obsahu</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Výhody školení ve škole */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Výhody školení přímo ve vaší škole
              </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-50 rounded-xl p-8 border border-slate-200">
                <School className="w-12 h-12 text-teal-600 mb-4" />
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  Ve známém prostředí
                </h3>
                <p className="text-slate-600">
                  Pedagogové se školí ve své škole, bez nutnosti dojíždění.
                </p>
              </div>

              <div className="bg-slate-50 rounded-xl p-8 border border-slate-200">
                <Clock className="w-12 h-12 text-teal-600 mb-4" />
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  Flexibilní termín
                </h3>
                <p className="text-slate-600">
                  Domluvíme si termín, který vyhovuje vašemu pedagogickému týmu.
                </p>
              </div>

              <div className="bg-slate-50 rounded-xl p-8 border border-slate-200">
                <Settings className="w-12 h-12 text-teal-600 mb-4" />
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  Přizpůsobený obsah
                </h3>
                <p className="text-slate-600">
                  Obsah školení upravíme podle potřeb vaší školy a pedagogů.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Jak školení probíhá */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Jak školení probíhá
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl border border-slate-200">
                <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0 text-teal-700 font-bold">
                  1
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Nezávazná poptávka</h3>
                  <p className="text-slate-600">Vyplníte formulář níže nebo nás kontaktujete.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-6 rounded-xl border border-slate-200">
                <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0 text-teal-700 font-bold">
                  2
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Domluva termínu a obsahu</h3>
                  <p className="text-slate-600">Domluvíme si termín a přizpůsobíme obsah vašim potřebám.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-6 rounded-xl border border-slate-200">
                <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0 text-teal-700 font-bold">
                  3
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Realizace školení</h3>
                  <p className="text-slate-600">Školení proběhne ve vaší škole v dohodnutém termínu (8 vyučovacích hodin).</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Formulář */}
        <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Nezávazně poptat termín školení
              </h2>
              <p className="text-lg text-teal-100">
                Vyplňte formulář a my se vám ozveme do 24 hodin.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-10 shadow-2xl">
              <QuickForm courseType="skoleni-pro-skoly" buttonText="Odeslat poptávku" variant="hero" />
            </div>

            <div className="mt-8 text-center">
              <p className="text-teal-50 mb-2">Nebo nás kontaktujte přímo:</p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="tel:+420732199307" className="inline-flex items-center gap-2 text-white hover:text-teal-100">
                  <Phone className="w-4 h-4" />
                  <span>+420 732 199 307</span>
                </a>
                <a href="tel:+420739921359" className="inline-flex items-center gap-2 text-white hover:text-teal-100">
                  <Phone className="w-4 h-4" />
                  <span>+420 739 921 359</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
